package com.merkost.handpass.api.dto.listing

import kotlinx.serialization.Serializable

@Serializable
data class PriceFacetsResponse(
    val totalCount: Long,
    val price: PriceDistributionDto
)

@Serializable
data class PriceDistributionDto(
    val minCents: Long,
    val maxCents: Long,
    val buckets: List<PriceBucketDto>
)

@Serializable
data class PriceBucketDto(
    val fromCents: Long,
    val toCents: Long,
    val count: Long
)
